import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  movie: MovieItem;
  size?: 'normal' | 'small';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg ${
        size === 'small' ? 'aspect-[3/4]' : 'aspect-[2/3]'
      }`}>
        <img
          src={movie.imageUrl}
          alt={movie.title}
          title={`${movie.title} - 蘑菇影视高清免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
          {movie.isHot && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
              热播
            </span>
          )}
          {movie.isNew && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
              新上线
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-[10px] font-bold bg-background-950/60 text-primary-300 rounded whitespace-nowrap">
            {movie.rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
            <i className="ri-play-circle-fill text-3xl text-background-50"></i>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <h3 className={`font-heading text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200 ${
          size === 'small' ? 'text-sm' : 'text-base'
        }`}>
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{movie.subcategory}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-400"></span>
          <span className="text-xs text-foreground-500">{movie.year}</span>
        </div>
        {movie.actors && (
          <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
            {movie.actors.slice(0, 3).join(' / ')}
          </p>
        )}
      </div>
    </Link>
  );
}